import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { withRouter } from "react-router";
import { useQuery, gql } from '@apollo/client';
import moment from 'moment'
import { useIntl, FormattedMessage } from "react-intl";
import {Helmet} from "react-helmet-async";
import {BsChevronLeft, BsChevronRight} from 'react-icons/bs';

import UstBannerAd from './components/ads/UstBannerAd'
import altTextKes from './utils/altTextKes'
import {
  Container,
  Row, Col, ColBr,
  Img,
  Button,
  Link,
  Breadcrumb, BreadcrumbItem, BreadcrumbSeparator
} from './StyledComponents.js'
import styled from 'styled-components'
import { useCsEvent } from './client/useEvents';

const BreadCrumbNav = styled.nav`
  background-color: transparent;
  padding: 0;
`
const GunButonu = styled(Button) `
  border-color: #343a40;
  padding: .25rem .5rem;
  font-size: .875rem;
  line-height: 1.5;
  border-radius: .2rem;
  &:hover {
    background-color: #343a40;
    border-color: #343a40;
  }
  a {
    color: #343a40;
  }
  a:hover {
    color: #fff;
  }
  ${props => props.disabled ? `
    color: #6c757d;
    pointer-events: none;
    cursor: auto;
    background-color: #fff;
    border-color: #dee2e6;

    * {
      color: #6c757d;
    }
  ` : ''}
`

const DayMarkdownBox = styled.div`
  background: linear-gradient(90deg, #f4f7fa 0%, #e9eef6 100%);
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(52,81,130,0.08);
  padding: 2rem 1.5rem;
  margin-bottom: 2rem;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  font-size: 1.15rem;
  color: #2d3a4a;
  line-height: 1.7;
  font-weight: 400;
  h1, h2, h3, h4, h5, h6 {
    color: #345182;
    font-weight: 700;
    margin-top: 1.2em;
    margin-bottom: 0.7em;
  }
  ul, ol {
    margin-left: 1.5em;
    margin-bottom: 1em;
  }
  p {
    margin-bottom: 1em;
  }
  a {
    color: #345182;
    text-decoration: underline;
    &:hover {
      color: #2a8c42;
    }
  }
`;

const sonrakiGunEventFire = (fireCsEvent) => {
  fireCsEvent({
    category: "Tarih",
    action: "Navigation",
    label: "Sonraki Gun"
  });
}

const gqlQuery = gql`
  query TarihPage($gun: Date!) {
    gazeteler {
      gazete
      gorunen_ad
      logo
      type
      dil
    },
    tarih(gun: $gun) {
      content
      sayilar {
        gazete,
        sayfa,
        thumbnail,
        alt_text,
      },
      oncekiGun,
      sonrakiGun,
      commonTags(gun: $gun, limit: 50) {
       tag
        count
      }
    }
  }
`

function TarihComponent(props) {
  const {tarih} = props.match.params
  const intl = useIntl()
  const fireCsEvent = useCsEvent()
  const [showFullMarkdown, setShowFullMarkdown] = useState(false);

  const {loading, data} = useQuery(gqlQuery, 
    {variables: {gun: tarih}})
  
  let {gazeteler, tarih: tarihData} = data || {};
  let {commonTags} = tarihData || {};
  let {sayilar, oncekiGun, sonrakiGun, content} = tarihData || {}

  gazeteler = gazeteler?.reduce((accu, gazete) => {
    accu[gazete.gazete] = gazete
    return accu
  }, {})

  const onSayiClick = () => {
    fireCsEvent({
      category: "Tarih",
      action: "Navigation",
      label: "Sayı linkine tıklandı"
    })
  }

  const handleShowMore = () => {
    fireCsEvent({
      category: "Tarih",
      action: "Engagement",
      label: "Show More Pressed"
    });
    setShowFullMarkdown(true);
  };

  const handleShowLess = () => {
    fireCsEvent({
      category: "Tarih",
      action: "Engagement",
      label: "Show Less Pressed"
    });
    setShowFullMarkdown(false);
  };

  return (
    <Container>
      {!loading && <React.Fragment>
        <Helmet>
          <title> {intl.formatMessage({id: "tarih.meta.title"}, 
              {tarih: moment(tarih).utc().format('LL')} )}</title>
          <meta name="description" 
            content={intl.formatMessage({id: "tarih.meta.description"}, 
              {tarih: moment(tarih).utc().format('LL')} )} />
          <meta name="og:description" 
              content={intl.formatMessage({id: "tarih.meta.description"}, 
              {tarih: moment(tarih).utc().format('LL')} )} />
        </Helmet>
        <Row>
          <Col className='d-flex justify-content-center align-middle mt-1'>
            <BreadCrumbNav className="d-flex" aria-label="breadcrumb">
              <Breadcrumb className="m-auto">
                <BreadcrumbItem>
                  <Link to={`/yil/${moment(tarih).utc().format('YYYY')}`} aria-label="Yıl ana sayfası">
                    <span>{moment(tarih).utc().format('YYYY')}</span>
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbSeparator>›</BreadcrumbSeparator>
                <BreadcrumbItem className="breadcrumb-item active" aria-current="page">
                  <FormattedMessage id="tarih.title" 
                      defaultMessage="{tarih} Tarihli gazeteler" 
                      values={{tarih: moment(tarih).utc().format('LL')}} />
                </BreadcrumbItem>
              </Breadcrumb>
            </BreadCrumbNav>
          </Col>
        </Row>
        <Row><Col className='d-flex justify-content-center align-middle mt-1'>
          <GunButonu 
              disabled={!oncekiGun} className={`mr-1`}
              onClick={() => {
                fireCsEvent({
                  category: "Tarih",
                  action: "Navigation",
                  label: "Onceki Gun"
                })
              }}
          >
            <Link to={oncekiGun ? `/tarih/${oncekiGun}` : '#'} >
              <div className="text-center"><BsChevronLeft size="2em"/></div>
              <div className="text-center">
                <FormattedMessage id="GazeteSayfası.oncekiGun" defaultMessage="Önceki Gün" />
              </div>
            </Link>
          </GunButonu>
          <GunButonu 
              disabled={!sonrakiGun} className={`ml-1`}
              onClick={() => sonrakiGunEventFire(fireCsEvent)}
          >
            <Link to={sonrakiGun ? `/tarih/${sonrakiGun}` : '#'}>
              <div className="text-center"><BsChevronRight size="2em"/></div>
              <div className="text-center">
                <FormattedMessage id="GazeteSayfası.sonrakiGun" defaultMessage="Sonraki Gün" />
              </div>
            </Link>
          </GunButonu>
        </Col></Row>
        {content && (
          <Row>
            <Col>
              <DayMarkdownBox style={{maxHeight: showFullMarkdown ? 'none' : '360px', overflow: showFullMarkdown ? 'visible' : 'hidden', position: 'relative'}}>
                <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem'}}>
                  <svg width="32" height="32" fill="none" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="#345182"/><path d="M16 8v8l6 3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  <span style={{margin: 0, color: '#345182', fontWeight: 700, fontSize: '1.5rem'}}>
                    <FormattedMessage id="tarih.gunBilgisi" defaultMessage="O gün neler oldu?" />
                  </span>
                </div>
                <ReactMarkdown
                  components={{
                    a: ({node, ...props}) => (
                      <a
                        {...props}
                        onClick={e => {
                          fireCsEvent({
                            category: "Tarih",
                            action: "Engagement",
                            label: "Markdown Link Click"
                          });
                          if (props.onClick) props.onClick(e);
                        }}
                      >
                        {props.children}
                      </a>
                    )
                  }}
                >
                  {content}
                </ReactMarkdown>
                {!showFullMarkdown && (
                  <div style={{position: 'absolute', left: 0, right: 0, bottom: 0, height: '80px', background: 'linear-gradient(0deg, #f4f7fa 80%, rgba(244,247,250,0.0) 100%)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center'}}>
                    <button
                      style={{
                        background: '#345182',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '18px',
                        padding: '8px 24px',
                        fontWeight: 500,
                        fontSize: '1rem',
                        boxShadow: '0 2px 8px rgba(52,81,130,0.08)',
                        cursor: 'pointer',
                        marginBottom: '12px',
                        zIndex: 2
                      }}
                      onClick={handleShowMore}
                    >
                      <FormattedMessage id="tarih.showMore" defaultMessage="Daha fazla göster" />
                    </button>
                  </div>
                )}
                {showFullMarkdown && (
                  <div style={{display: 'flex', justifyContent: 'center', marginTop: '1em'}}>
                    <button
                      style={{
                        background: '#e9eef6',
                        color: '#345182',
                        border: 'none',
                        borderRadius: '18px',
                        padding: '8px 24px',
                        fontWeight: 500,
                        fontSize: '1rem',
                        boxShadow: '0 2px 8px rgba(52,81,130,0.08)',
                        cursor: 'pointer',
                        marginBottom: '12px',
                        zIndex: 2
                      }}
                      onClick={handleShowLess}
                    >
                      <FormattedMessage id="tarih.showLess" defaultMessage="Daha az göster" />
                    </button>
                  </div>
                )}
              </DayMarkdownBox>
            </Col>
          </Row>
        )}
        <Row><Col>
          <h2 className={"d-flex justify-content-center"}>
            <FormattedMessage id="tarih.title" 
                defaultMessage="{tarih} Tarihli gazeteler" 
                values={{tarih: moment(tarih).utc().format('LL')}} />
          </h2>
        </Col></Row>
        <UstBannerAd />
        <Row>
        {sayilar.map((sayi, i) => { return (
          <React.Fragment key={sayi.gazete}>
            <ColBr key={i} className="mb-2 d-flex justify-content-center" >
              <Link to={`/gazete/${sayi.gazete}/${tarih}/${sayi.sayfa}`} onClick={onSayiClick}>
                <h3 className='d-flex mt-2 mb-2 justify-content-center'>{gazeteler?.[sayi.gazete]?.gorunen_ad}</h3>
                <Img src={`${process.env.REACT_APP_GA_CDN_URL}/${sayi.thumbnail}`} 
                    alt={sayi.caption || altTextKes(sayi.alt_text, 125) || `Sayfa ${sayi.sayfa}`} 
                />
              </Link>
            </ColBr>
          </React.Fragment>)
        })}
        </Row>
        {/* Most Common Tags Section */}
        {commonTags && commonTags.length > 0 && (
          <Row>
            <Col>
              <div style={{margin: '2rem 0', textAlign: 'center'}}>
                <h3 style={{color: '#345182', fontWeight: 700, marginBottom: '1rem'}}>
                  <FormattedMessage id="tarih.commonTags" defaultMessage="Bu günün etiketleri" />
                </h3>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: '0.5rem', justifyContent: 'center'}}>
                  {commonTags.map(tagObj => (
                    <Link
                      key={tagObj.tag}
                      to={`/etiket/${encodeURIComponent(tagObj.tag)}`}
                      style={{
                        background: '#e9eef6',
                        color: '#345182',
                        borderRadius: '16px',
                        padding: '6px 16px',
                        fontWeight: 500,
                        textDecoration: 'none',
                        fontSize: '1rem',
                        boxShadow: '0 2px 8px rgba(52,81,130,0.08)',
                        margin: '4px'
                      }}
                      onClick={() => {
                        fireCsEvent({
                          category: "Tarih",
                          action: "Engagement",
                          label: "Etiket link click"
                        });
                      }}
                    >
                      #{tagObj.tag} <span style={{color: '#6c757d', fontSize: '0.9em'}}>({tagObj.count})</span>
                    </Link>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        )}        
      </React.Fragment>}
    </Container>
  )
}

export default withRouter(TarihComponent);
